import { Component } from '@angular/core';

@Component({
  selector: 'blank-layout',
  templateUrl: './blank.component.html',
  styleUrls: []
})
export class BlankComponent {
}


// WEBPACK FOOTER //
// ./src/app/layouts/blank/blank.component.ts